/**
 * Оповещение о восстановлении связи.
 *
 * Отдельный файл от самого подключения к Centrifugo не ради красоты: клиент
 * websocket весит около сотни килобайт, и приложению незачем грузить его
 * до того, как понадобится живое обновление. Здесь только список слушателей,
 * поэтому точка входа может подписаться, ничего за собой не притащив.
 */

const listeners = new Set<() => void>();

/** Подписаться на восстановление связи. Возвращает функцию отписки. */
export function onReconnect(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Сообщить, что связь восстановлена. Вызывает подключение, а не экраны. */
export function notifyReconnected(): void {
  for (const listener of listeners) {
    listener();
  }
}
